import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

type Tail = "bottom-left" | "bottom-center" | "bottom-right";

type Props = {
  children: ReactNode;
  tail?: Tail;
  className?: string;
};

const TAIL_POS: Record<Tail, string> = {
  "bottom-left": "left-8",
  "bottom-center": "left-1/2 -translate-x-1/2",
  "bottom-right": "right-8",
};

/**
 * Biały dymek dialogowy z trójkątnym ogonkiem skierowanym w dół. Używany
 * przy maskotkach (np. parent-philosophy moment). Ogonek robiony przez
 * border-trick na pseudo-spanach — bez SVG.
 */
export function SpeechBubble({
  children,
  tail = "bottom-center",
  className,
}: Props) {
  return (
    <div
      className={cn(
        "relative rounded-[24px] bg-white px-5 py-4 text-navy text-[15px] leading-snug shadow-bubble",
        className,
      )}
    >
      {children}
      <span
        aria-hidden
        className={cn(
          "absolute -bottom-[11px] h-0 w-0",
          "border-l-[12px] border-r-[12px] border-t-[12px]",
          "border-l-transparent border-r-transparent border-t-white",
          TAIL_POS[tail],
        )}
        style={{ filter: "drop-shadow(0 2px 1px rgba(0,0,0,0.06))" }}
      />
    </div>
  );
}
